import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { first } from 'rxjs/operators';

@Component({
  selector: 'localizer-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private router: Router) {
    this.router.events.pipe(first()).subscribe(event => {
     if (event instanceof NavigationEnd) {
       (<any>window).ga('set', 'page', event.urlAfterRedirects);
       (<any>window).ga('send', 'pageview');
     }
    });
    (<any>window).cookieconsent.initialise({
      'palette': {
        'popup': {
          'background': '#C4C4C4'
        },
        'button': {
          'background': '#ff0057',
          'text': '#fcfcfc'
        }
      },
      'content': {
        'message': `Our site uses cookies for analytics. If you're unsure about it, take a look at our privacy policy.`,
        'dismiss': 'Accept',
        'link': 'Privacy policy',
        'href': 'https://wanari.com/privacy-policy'
      }
    });
 }
}
